import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import PopupWrapper from "../../../Common/PopupWrapper";
import isEqual from "lodash/isEqual";
import PlaceholderWrapper from "../../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import GridViewInlineEdit2 from "@mnjsplatform/components/lib/common/GridView/GridViewInlineEdit2";

class ITEquipment extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            rowKey: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        //await this.props.dispatch(this.props.dataItem_ComplectInfo.reset());
        await this.props.dispatch(this.props.dataItem_ComplectList.execute({StateRuleCode: this.props.stateRuleCode}));
    }

    gridRowStyleProvider = (rowIndex, row) => {
        let style = {cursor: "pointer"};
        const rowKey = this.props.dataItem_ComplectList.getRowKeyByIndex(rowIndex);
        if (isEqual(rowKey, this.state.rowKey)) {
            return {
                ...style,
                backgroundColor: '#AAD4FF', fontWeight: 'bold'
            };
        }
        return style;
    }

    renderCellEx = (cellParams) => {
        if(cellParams.fieldInfo.Name === "IsSelected"){
            return (<input type="checkbox" checked={cellParams.row.IsSelected === 1}
                           disabled={this.props.readOnly} readOnly={this.props.readOnly}
                           onChange={async() => {
                               await this.props.dispatch(cellParams.dataItem.setField(cellParams.rowIndex,
                                   cellParams.fieldInfo.Name,
                                   (cellParams.row[cellParams.fieldInfo.Name] === 1 ? 0 : 1)));
                               await this.props.dispatch(cellParams.dataItem.save(cellParams.rowIndex));
                           }}
            />)
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    render() {
        if (!this.props.dataItem_ComplectList.isInitialized) {
            return null;
        }
        return (<PopupWrapper title={i18next.t("IT_Equipment") + `: ${this.props.stateRuleCode}`} onClose={this.props.onClose} popupVisible={true}
                              instructionId="ITEquipment">
            <PlaceholderWrapper placeholderId="10" title={i18next.t("Kits")} showSplitterLine={false}
                                canCollapse={false}>
                <GridView dataItem={this.props.dataItem_ComplectList} readOnly={true}
                          rowStyleProvider={this.gridRowStyleProvider}
                          renderCellEx={this.renderCellEx}
                          //overrideVisibility={{IsSelected: !this.props.readOnly}}
                          updateStateFlag={this.state.rowKey}
                          pageSize={10} allowPagination={true} activePageSize={5} rowCursor="pointer"
                          onCellClick={this.onSelectRow}
                />
            </PlaceholderWrapper>
            {this.props.dataItem_ComplectInfo.isInitialized &&
                <PlaceholderWrapper placeholderId="20" title={i18next.t("Composition")} canCollapse={true}
                                    showSplitterLine={false}>
                    <GridView dataItem={this.props.dataItem_ComplectInfo} readOnly={true} showHeader={false}
                              pageSize={10} allowPagination={true} activePageSize={5}/>
                </PlaceholderWrapper>}
        </PopupWrapper>);
    }
    onSelectRow = async (row, fieldInfo, e) => {
        if(fieldInfo.Name !== 'IsSelected' || this.props.readOnly) {
            const rowKey = this.props.dataItem_ComplectList.getRowKey(row);
            await this.props.dispatch(this.props.dataItem_ComplectInfo.execute(rowKey));
            this.setState({rowKey});
        }
    }
}

ITEquipment.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_ComplectList: PropTypes.object,
    dataItem_ComplectInfo: PropTypes.object,
    onClose: PropTypes.func,
    stateRuleCode: PropTypes.string,
    readOnly: PropTypes.bool
}
ITEquipment.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_ComplectList: state.subRemoteWorkState.RemoteWorkHardwareSet_ListForPO,
        dataItem_ComplectInfo: state.subRemoteWorkState.RemoteWorkHardwareSet_ListHWSetForPO
    }
}

export default connect(mapStateToProps)(ITEquipment)